var map = {
	"./aircon.png": "vP13",
	"./brakes.png": "GaHl",
	"./carhoist.png": "pmd2",
	"./diff.png": "U5h1",
	"./gears.png": "/rBm",
	"./radiator.png": "aaTX",
	"./spanner.png": "Oi5r",
	"./speedo.png": "/hId",
	"./spring.png": "FiJB",
	"./wheel.png": "R3BA",
	"./wheel_outline.png": "1vkw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fxt7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services ^\.\/.*$
// module id = fxt7
// module chunks = 1